import React, { useState } from 'react';
import Timesheet from './Timesheet';

const AdminTimesheetViewer = ({ db, usersList }) => {
    const [selectedDriver, setSelectedDriver] = useState('');

    // Filter list to show only users who have a timesheet required
    const timesheetUsers = [...usersList]
      .filter(u => u.timesheetRequired)
      .sort((a, b) => String(a.displayName || a.initials || '').localeCompare(String(b.displayName || b.initials || ''), undefined, { sensitivity: 'base' }));

    return (
        <div className="card" style={{maxWidth:'1000px', margin:'0 auto'}}>
            <h3 style={{marginBottom:'20px'}}>View Driver Timesheets</h3>
            <div style={{marginBottom:'20px'}}>
                <label style={{fontSize:'12px', fontWeight:'bold', display:'block', marginBottom:'5px'}}>Select Timesheet:</label>
                <select 
                    value={selectedDriver} 
                    onChange={(e) => setSelectedDriver(e.target.value)}
                    style={{width:'100%', padding:'10px'}}
                >
                    <option value="">-- Select Timesheet --</option>
                    {timesheetUsers.map(u => (
                        <option key={u.initials} value={u.initials}>{u.displayName}</option>
                    ))}
                </select>
            </div>
            
            {selectedDriver ? (
                <div style={{borderTop:'1px solid var(--border)', paddingTop:'20px'}}>
                    <Timesheet db={db} initials={selectedDriver} />
                </div>
            ) : (
                <p style={{fontStyle:'italic', color:'var(--text-muted)', textAlign:'center'}}>Please select a user to view their timesheet.</p>
            )}
        </div>
    );
};

export default AdminTimesheetViewer;